import React, { Fragment } from "react";
import { Route, withRouter } from "react-router-dom";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import routes from "../../global/routes";

import SessionHOC from "../HOC/sessionHOC";
import SpinnerHOC from "../HOC/spinnerHOC";
import WelcomeModal from "../WelcomeModal/index";

import "./main.scss";
import "../../../src/global/containers/TableOFLC.scss";

class MainContent extends React.PureComponent {
  isMatchingSlash(path, route_path) {
    if (route_path === "/") {
      return path.length <= 1;
    }
  }

  getDocumentTitle(path) {
    let title = document.title;
    routes.map((route) => {
      if (typeof route.path === "string") {
        let route_path = route.path.replace(":id", "");

        if (
          path.includes(route_path) &&
          !this.isMatchingSlash(path, route_path)
        ) {
          title = route.title;
        }
      }
    });
    return title;
  }

  componentDidMount() {
    document.title = this.getDocumentTitle(window.location.pathname);
  }

  componentDidUpdate() {
    document.title = this.getDocumentTitle(window.location.pathname);
  }

  render() {
    return (
      <Fragment>
        <WelcomeModal />
        <div className="main-content usa-grid">
          <div className="styleguide-content usa-content usa-main-content">
            {routes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                render={route.main}
              />
            ))}
          </div>
        </div>
      </Fragment>
    );
  }
}

Route.propTypes = {
  path: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.appReducer.userDataReducer.data,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(SessionHOC(SpinnerHOC("currentUser")(MainContent)))
);
